import {useTranslationForPageInVehicleProjects} from '../../VehicleProjects/hooks/vehicleProjectsTranslationHooks';

export const useBaselinesTranslations = () => {
	return useTranslationForPageInVehicleProjects('baselines');
};
